<template>
  <div>
    <!-- 新增、编辑合同 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <el-form :model="formData" ref="formData" :rules="rules" label-width="110px">
        <el-form-item prop="names" label="入住申请单">
          <el-autocomplete
            style="width: 100%"
            :disabled="isShow"
            v-model="formData.names"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入人才姓名"
            value-key="opinion"
            clearable
            @clear="clearSearch"
            @select="handleSelect"
            ref="myAutocomplete"
          ></el-autocomplete>
        </el-form-item>
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="company" label="所属单位">
            <el-input
              style="width: 100%"
              v-model="formData.company"
              disabled=""
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" label="人才">
            <el-input disabled="" v-model="formData.name"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="roomNum" label="入住房间">
            <el-input v-model="formData.roomNum" disabled></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="isSelectOtherRoom" :disabled="isShow && !isEdit"
              >换一间</el-checkbox
            >
          </el-form-item>
        </div>
        <el-form-item v-if="isSelectOtherRoom" prop="roomSelected" label="新的房间">
          <!--el-input v-model="formData.roomNum"></el-input-->
          <el-cascader
            v-model="formData.roomSelected"
            :options="options"
            placeholder="请选择客房"
            :show-all-levels="false"
            @change="toSelectOtherRoom"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="time" label="登记时间">
          <el-date-picker
            :disabled="isShow && !isEdit"
            type="datetime"
            placeholder="选择入住日期"
            v-model="formData.time"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="fileName" label="附件(身份证)">
          <el-upload
            :limit="1"
            :disabled="isShow && !isEdit"
            multiple
            action="/api/admin/roomManage/uploadRoomFile"
            :on-remove="removeFile"
            :file-list="fileList"
            name="file"
            :on-preview="uploadDown"
            :headers="headers"
            :on-success="uploadSuccess"
          >
            <el-button size="small" type="primary" :disabled="isShow && !isEdit"
              >点击上传文件(身份证)</el-button
            >
          </el-upload>
        </el-form-item>
        <div style="display: flex; justify-content: space-between">
          <el-form-item label="选择楼栋" prop="building">
            <el-select
              :disabled="!isSelectOtherRoom"
              v-model="formData.building"
              placeholder="请选择"
            >
              <el-option label="A栋" value="A栋"></el-option>
              <el-option label="B栋" value="B栋"></el-option>
              <el-option label="C栋" value="C栋"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="押金" prop="deposit">
            <el-input
              :disabled="isShow && !isEdit"
              type="number"
              style="width: 100%"
              v-model="formData.deposit"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="当前状态" prop="status">
          <el-radio
            :disabled="isShow && !isEdit"
            v-model="formData.status"
            label="正常"
          ></el-radio>
          <el-radio
            :disabled="isShow && !isEdit"
            v-model="formData.status"
            label="封禁"
          ></el-radio>
        </el-form-item>
        <el-form-item label="权限有效日期" prop="times">
          <el-date-picker
            :disabled="isShow && !isEdit"
            style="width: 100%"
            v-model="formData.times"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div>
            <el-checkbox
              :disabled="isShow && !isEdit"
              v-for="item in qx"
              v-model="formData.menus"
              :label="item.id"
            >
              {{ item.name }}</el-checkbox
            >
          </div>
        </el-form-item>
        <div style="">
          <el-form-item label="车牌号" prop="carNum">
            <el-input
              :disabled="isShow && !isEdit"
              style="width: 100%"
              v-model="formData.carNum"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="isShow" prop="checkList" label="人才是否确认">
          <el-checkbox
            :disabled="isShow && !isEdit"
            v-model="formData.fireFlag"
            label="消防安全责任书"
          ></el-checkbox>

          <el-checkbox
            :disabled="isShow && !isEdit"
            v-model="formData.propertyFlag"
            label="公寓入住手册"
          ></el-checkbox>
        </el-form-item>
        <div v-if="isShow && !isEdit">
          <div style="display: flex; justify-content: space-between">
            <el-form-item prop="createName" label="创建人">
              <el-input v-model="formData.createName" :disabled="isShow"></el-input>
            </el-form-item>
            <el-form-item prop="createTime" label="创建时间">
              <el-input v-model="formData.createTime" :disabled="isShow"></el-input>
            </el-form-item>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="linkMan" label="紧急联系人">
            <el-input
              style="width: 100%"
              v-model="formData.linkMan"
              :disabled="isShow && !isEdit"
            ></el-input>
          </el-form-item>
          <el-form-item prop="relations" label="关系">
            <el-input
              style="width: 100%"
              v-model="formData.relations"
              :disabled="isShow && !isEdit"
            ></el-input>
          </el-form-item>
        </div>
        <div style="display: flex; justify-content: space-between">
          <el-form-item prop="linkMobile" label="联系电话">
            <el-input
              :disabled="isShow && !isEdit"
              v-model="formData.linkMobile"
            ></el-input>
          </el-form-item>
        </div>

        <div>
          <div
            v-if="isEdit"
            style="display: flex; margin-bottom: 20px; margin-left: 10px"
          >
            <div>同住人</div>
            <div class="inboxButton" @click="addRoommate">+</div>
            <div class="inboxButton" @click="delRoommate">-</div>
          </div>
          <div v-for="(item, index) in formData.member" :key="index">
            <div style="margin-left: 20px">同住人{{ index + 1 }}</div>
            <div style="display: flex; justify-content: space-between">
              <el-form-item label="姓名">
                <el-input
                  style="width: 100%"
                  v-model="item.name"
                  :disabled="isShow && !isEdit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="关系">
                <el-input
                  style="width: 100%"
                  v-model="item.relations"
                  :disabled="isShow && !isEdit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: space-between">
              <el-form-item label="联系电话">
                <el-input
                  style="width: 100%"
                  v-model="item.phone"
                  :disabled="isShow && !isEdit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="单位">
                <el-input
                  style="width: 100%"
                  v-model="item.company"
                  :disabled="isShow && !isEdit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: space-between">
              <el-form-item label="身份证号码">
                <el-input
                  style="width: 100%"
                  v-model="item.idCard"
                  :disabled="isShow && !isEdit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-input
                  style="width: 100%"
                  v-model="item.gender"
                  :disabled="isShow && !isEdit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <span v-if="!isShow" slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="confirmClick">确 定</el-button>
      </span>
      <span v-else slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button v-if="isEdit" type="primary" @click="submitAgree">确定入住</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import downloadFile from "../../../assets/js/downloadFile.js";
export default {
  props: ["title", "dialogVisible", "obj"],
  watch: {
    title: function (val) {
      console.log(val);
      if (val == "新增登记") {
        this.getQx();
        this.formData = {
          ...this.oldFormData,
        };
        this.fileList = [];
        this.isShow = false;
        this.isEdit = true;
      } else if (val == "入住审核") {
        this.getQx();
        this.formData = {
          ...this.obj,
        };
        this.handleSelect(this.formData);

        if (this.formData.startTime) {
          this.formData.times = [this.formData.startTime, this.formData.endTime];
        }
        console.log("obj:", JSON.stringify(this.obj));
        console.log(this.formData);
        this.formData.names = this.formData.name;

        if (this.formData.propertyFlag == "已确认") {
          this.formData.propertyFlag = true;
        } else {
          this.formData.propertyFlag = false;
        }
        if (this.formData.fireFlag == "已确认") {
          this.formData.fireFlag = true;
        } else {
          this.formData.fireFlag = false;
        }
        this.formData.member = JSON.parse(this.formData.members);
        this.formData.filePath = this.obj.filePath;
        this.formData.fileName = this.obj.fileName;
        console.log(this.formData.filePath);
        // this.formData.roomNumber = this.formData.roomNumber
        // this.formData.filePath=this.formData.showPath
        // if (this.formData.fileRes != null) {
        let newFiles = [];
        if (this.formData.filePath) {
          newFiles.push({
            name: this.formData.fileName,
            url: this.formData.filePath,
          });
        }
        this.fileList = newFiles;
        console.log(this.fileList);
        // this.fileList[0] = this.formData.showPath;
        // }
        this.isShow = true;
        this.isEdit = true;
      } else {
        this.handleSelect(this.formData);
        this.isEdit = false;
        this.getQx();
        this.formData = {
          ...this.obj,
        };
        // this.formData.times = [this.formData.startTime, this.formData.endTime]
        if (this.formData.startTime) {
          this.formData.times = [this.formData.startTime, this.formData.endTime];
        }
        console.log(this.formData);
        this.formData.names = this.formData.name;

        if (this.formData.propertyFlag == "已确认") {
          this.formData.propertyFlag = true;
        } else {
          this.formData.propertyFlag = false;
        }
        if (this.formData.fireFlag == "已确认") {
          this.formData.fireFlag = true;
        } else {
          this.formData.fireFlag = false;
        }
        this.formData.member = JSON.parse(this.formData.members);
        // this.formData.roomNumber = this.formData.roomNumber
        // this.formData.filePath=this.formData.showPath
        // if (this.formData.fileRes != null) {
        let newFiles = [];

        if (this.formData.filePath) {
          newFiles.push({
            name: this.formData.fileName,
            url: this.formData.filePath,
          });
        }
        this.fileList = newFiles;
        console.log(this.fileList);
        // this.fileList[0] = this.formData.showPath;
        // }
        this.isShow = true;
      }
    },
  },
  data() {
    return {
      headers: {
        Authorization: localStorage.access_token,
      },
      isShow: null,
      isEdit: false,
      qx: [], //权限列表
      disabled: false,
      fileList: [],
      options: [],
      oldFormData: "", //初始数据备份
      isSelectOtherRoom: false,
      formData: {
        checked1: false,
        checked2: false,
        checkInTime: null,
        endTime: null,
        // roomNumber: null,
        region: null,
        names: "",
        name: null,
        checkList: "",
        signingDate: null,
        files: [],
        filePath: "",
        company: null,
        status: null,
        contents: null,
        number: null,
        requirement: null,
        member: null,
        fileName: "",
        roomNum: null,
        roomNumber: null,
        newRoomNumber: null,
        userId: null,
        checkInId: null,
        time: null,
        times: "",
        startTime: "", //权限起始时间
        endTime: "", //权限截止时间
        menus: [], //权限范围id集合.
        status: "正常", //当前状态（封禁，正常）
        building: "A栋", //楼栋
        roomSelected: ["", "", ""],
        deposit: 0,
        member: [],
        members: "",
      },
      rules: {
        time: [
          {
            required: true,
            message: "登记日期不能为空",
            trigger: ["blur", "change"],
          },
        ],
        endTime: [
          {
            required: true,
            message: "截止日期不能为空",
            trigger: ["blur", "change"],
          },
        ],
        names: [
          {
            required: true,
            message: "入住申请单不能为空",
            trigger: ["blur", "change"],
          },
        ],
        roomNum: [
          {
            required: true,
            message: "房间号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        roomNumber: [
          {
            required: true,
            message: "房间号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        company: [
          {
            required: true,
            message: "所属单位不能为空",
            trigger: ["blur", "change"],
          },
        ],
        fileName: [
          {
            required: true,
            message: "附件不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      restaurants: [],
      state: "",
      timeout: null,
    };
  },
  methods: {
    addRoommate() {
      let data = {
        name: "",
        gender: "",
        idCard: "",
        relations: "",
        phone: "",
        company: "",
      };
      console.log(this.formData);
      this.formData.member.push(data);
    },
    delRoommate() {
      if (this.formData.member.length > 0) {
        this.formData.member.pop();
      }
    },
    getQx() {
      //新增修改的时候获取权限
      this.$http.get("/api/oneCardSolution/getUserMenus").then((res) => {
        this.qx = res.data.data;
      });
    },
    getRoomTree(company) {
      let newRoomTree = [];
      this.$http.get("/api/roomManage/getRoomTree?company=" + company).then((res) => {
        //console.log('RoomTree：',JSON.stringify(res.data.data));
        res.data.data.forEach((item1, index1) => {
          newRoomTree.push({
            value: item1.building,
            label: item1.building,
            children: [],
          });
          item1.getStoreyRoomResList.forEach((item2, index2) => {
            newRoomTree[index1].children.push({
              value: item2.storey,
              label: item2.storey,
              children: [],
            });
            item2.getRoomResList.forEach((item3, index3) => {
              newRoomTree[index1].children[index2].children.push({
                value: item3.id,
                label: item3.roomNumber,
              });
            });
          });
        });
        this.options = newRoomTree;
        //console.log('可选房间列表：', JSON.stringify(newRoomTree));
      });
    },
    handleSelect(item) {
      //console.log('选中的',JSON.stringify(item));

      this.formData.company = item.company;
      this.formData.userId = item.userId;
      this.formData.checkInId = item.id;
      this.formData.roomNum = item.roomNum;
      //this.formData.building  = item.building
      this.formData.roomNumber = item.roomNumber;
      this.formData.deposit = item.deposit || 0;
      this.formData.name = item.name;

      this.getRoomTree(item.company);
      //this.getRoomById(item.roomNumber);

      //this.isShow = true;

      console.log("formData:", JSON.stringify(this.formData));
    },
    toSelectOtherRoom() {
      console.log("selected building:", JSON.stringify(this.formData.roomSelected));
      this.formData.building = this.formData.roomSelected[0];
      this.formData.newRoomNumber = this.formData.roomSelected[2];
      this.getRoomById(this.formData.newRoomNumber); //再次查询所选房间信息
    },
    selectOtherRoom() {
      this.isSelectOtherRoom = true;
    },
    getRoomById(roomNumber) {
      this.$http.get("/api/roomManage/getOneRoom?id=" + roomNumber).then((res) => {
        let room = res.data.data;
        this.formData.roomSelected[0] = room.building;
        this.formData.roomSelected[1] = room.storey + "楼";
        this.formData.roomSelected[2] = room.id;
        this.formData.building = room.building;

        console.log(
          "入住房间详情 roomSelected：",
          JSON.stringify(this.formData.roomSelected)
        );
        console.log("入住房间详情 building：", this.formData.building);
      });
    },
    tableParValueChange(value, currency, decimals) {
      const digitsRE = /(\d{3})(?=\d)/g;
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return "";
      currency = currency != null ? currency : "$";
      decimals = decimals != null ? decimals : 2;
      var stringified = Math.abs(value).toFixed(decimals);
      var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
      var i = _int.length % 3;
      var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? "," : "") : "";
      var _float = decimals ? stringified.slice(-1 - decimals) : "";
      var sign = value < 0 ? "-" : "";
      this.formData.money =
        sign + currency + head + _int.slice(i).replace(digitsRE, "$1,") + _float;
    },

    uploadDown(obj) {
      console.log(obj);
      this.$confirm("确定下载该文件吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          downloadFile(obj);
          this.$message({
            type: "success",
            message: "下载成功!",
          });
        })
        .catch((err) => {
          this.$message({
            type: "success",
            message: "取消下载!",
          });
        });
    },
    querySearchAsync(queryString, cb) {
      if (this.formData.name == undefined) {
        this.formData.name = "";
      }
      this.$http
        .get(`/api/bdCheckInRegister/getCheckInApplyByStatus?name=${this.formData.names}`)
        .then((res) => {
          console.log("查询所有单位信息", res.data.data);
          res.data.data.forEach((val) => {
            console.log(val.checkInTime);
            var a = val.checkInTime.split("T")[0];
            var b = a.split("T")[0];
            val.opinion = val.company + "-" + val.name + "-" + b;
          });

          let result = res.data.data;
          cb(result);
        });
    },
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus();
    },
    removeFile(file, fileList) {
      this.formData.filePath = "";
      this.formData.fileName = "";
    },
    //上传附件
    detailFileList(fileList) {
      console.log(fileList);
      // fileList.forEach((item) => {
      // 	if (item.hasOwnProperty('response')) {
      // 		newFiles.push({
      // 			name: item.name,
      // 			url: item.response.data
      // 		})
      // 	} else {
      // 		newFiles.push({
      // 			name: item.name,
      // 			url: item.url
      // 		});
      // 	}
      // })
      this.formData.filePath = fileList[0].response.data.filePath;
      this.formData.fileName = fileList[0].response.data.fileName;
    },
    uploadSuccess(response, file, fileList) {
      this.detailFileList(fileList);
    },
    // 取消
    cancelClick() {
      this.close();
    },
    // 确定
    confirmClick() {
      if (this.formData.times) {
        this.formData.endTime = new Date(this.formData.times[1]).getTime();
        this.formData.startTime = new Date(this.formData.times[0]).getTime();
      } else {
        this.formData.startTime = "";
        this.formData.endTime = "";
      }
      let status = true;
      let index = 0;
      this.formData.member.forEach((element, index) => {
        if (status) {
          if (
            element.name == "" ||
            element.idCard == "" ||
            element.phone == "" ||
            element.company == ""
          ) {
            status = false;
            index = index;
          }
        }
      });
      if (!status) {
        this.$message.error(`请认真完善同住人${index + 1}的信息！`);
        return;
      }
      this.$refs.formData.validate((valid) => {
        if (valid) {
          // this.formData.name = this.formData.names
          this.$emit("addSubmit", this.formData);
        } else {
          return;
        }
      });
    },
    // 确定入住
    submitAgree() {
      if (this.formData.times) {
        this.formData.endTime = new Date(this.formData.times[1]).getTime();
        this.formData.startTime = new Date(this.formData.times[0]).getTime();
      } else {
        this.formData.startTime = "";
        this.formData.endTime = "";
      }
      let status = true;
      let index = 0;
      this.formData.member.forEach((element, index) => {
        if (status) {
          if (
            element.name == "" ||
            element.idCard == "" ||
            element.phone == "" ||
            element.company == ""
          ) {
            status = false;
            index = index;
          }
        }
      });
      if (!status) {
        this.$message.error(`请认真完善同住人${index + 1}的信息！`);
        return;
      }
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.formData.members = JSON.stringify(this.formData.member);
          this.$emit("submitAgree", this.formData);
        } else {
          return;
        }
      });
    },
    // 关闭之前的回调
    handleClose(done) {
      this.close();
    },
    // 关闭模态框向父组件传dialogVisible
    close() {
      this.$parent.addClose();
    },
  },
  created() {
    this.oldFormData = JSON.parse(JSON.stringify(this.formData));
    // this.getRoomTree("");
  },
};
</script>

<style scoped="scoped">
.inboxButton {
  width: 30px;
  text-align: center;
  background-color: #51aefa;
  color: #ffffff;
  margin-left: 25px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
